<div class="row">
    <div class="col-12 col-sm-12 col-md-offset-3 col-md-6">
        <div class="form-description">
            <label>New Password</label>
            <ul>
                <li>must have 8 or more characters</li>
                <li>must contain at least 1 UPPERCASE letter</li>
                <li>must contain at least 1 lowercase letter</li>
                <li>must contain at least 1 symbol (eg %, $, ^, etc)</li>
                <li>must contain at least 1 number</li>
            </ul>
        </div>
        <form
            class="formly form"
            role="form"
            validate
            [formGroup]="form"
            (ngSubmit)="submit()"
        >
            <formly-form [model]="entity" [fields]="fields" [form]="form">
            </formly-form>
            <div class="col-12 col-sm-12 col-md-6">
                <div class="clearfix"></div>
                <div class="btn-group" role="group">
                    <button
                        type="submit"
                        [disabled]="form.invalid"
                        class="btn btn-primary"
                    >
                        Update
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
